export { SliderThumbs } from './slider-thumbs'
